<template>
    <div id="NewsPage" v-wechat-title="pageTitle">
        <no-data v-if="isNoData" class="no-data-box" />

        <div v-else>
            <div class="news-box" v-for="item in newsList" :key="item.noticeId" @click="toNewsDetail(item)">
                <!-- <img v-if="item.noticeCoverStream && pageTitle !='企业新闻'" alt="" class="news-left"
                    :src="'data:' + item.fileType + ';base64,' + item.noticeCoverStream"> -->
                <!-- .replace('http://nethall.cloud4water.com/nethall/dev-yixing/api', '') -->
                <img v-if="item.noticeCover && pageTitle !='企业新闻'" class="news-left" :src="baseUrl + item.noticeCover" alt="avatar">
                <img v-if="!item.noticeCover && pageTitle !='企业新闻'" class="news-left" :src="defaultImg" alt="">
                <div v-if="!item.noticeCover && pageTitle !='企业新闻'" class="bg-text">{{ pageTitle }}</div>
                <ul class="news-right">
                    <li>{{ item.noticeTitle }}</li>
                    <!-- <li>{{ dayjs(item.releaseTime).format('YYYY-MM-DD') }}</li> -->
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
// import dayjs from 'dayjs';
import serverconfig from "@/api/server.config";
let HALL_WECHAT_API = serverconfig.API;
const newsList = [
    {
        noticeId: 1,
        noticeTitle: '“廉洁进项目”创清廉企业工11二体UR饿哦IE荣我和个人光和热光和热high俄日',
        releaseTime: '2021/11/09',
    },
    {
        noticeId: 2,
        noticeTitle: '“廉洁进项目”创清廉企业工11二体UR饿哦IE荣我和个人光和热光和热high俄日',
        releaseTime: '2021/11/09',
    },
    {
        noticeId: 3,
        noticeTitle: '“廉洁进项目”创清廉企业工11二体UR饿哦IE荣我和个人光和热光和热high俄日',
        releaseTime: '2021/11/09',
    },
    {
        noticeId: 4,
        noticeTitle: '“廉洁进项目”创清廉企业工11二体UR饿哦IE荣我和个人光和热光和热high俄日',
        releaseTime: '2021/11/09',
    },
    {
        noticeId: 5,
        noticeTitle: '“廉洁进项目”创清廉企业工11二体UR饿哦IE荣我和个人光和热光和热high俄日',
        releaseTime: '2021/11/09',
    }
]

import NoData from '@/components/noData';
import { selectNoticeList, selectNoticeDetail, calcReadNum } from '@/api/user';
export default {
    name: 'NewsList',
    components: {
        NoData,
    },
    data() {
        return {
            // newsList,
            newsList: [],
            refreshing: false,
            finished: false,
            finishedText: '',
            loading: false,
            currentPage: 1,
            pageSize: 10,
            dataTotal: 0,
            noticeType: this.$route.query.newsCode || 'orgnews',
            pageTitle: this.$route.query.pageTitle,
            defaultImg: require("./bg.png"),
            baseUrl: HALL_WECHAT_API + '/biz/file/view?fileId=',
            isNoData: false
        }
    },
    mounted() {
        this.getNotice();
    },
    methods: {
        // dayjs,
        async getNotice() {
            // this.newsList = [{"noticeId":"1921761882846859265","noticeType":"waterquality","noticeTitle":"2025年第一季度王家山水厂水质检测报告","releaseTime":"2025-05-12 10:55:18","startTime":"2025-05-12 00:00:00","endTime":"2099-12-31 23:59:59","waterCutArea":null,"noticeCover":null,"noticeDescribe":"<p><img style=\"max-width: 100%\" src=\"/main/biz/file/view?fileId=1921761719978332161\"/></p><p><img style=\"max-width: 100%\" src=\"/main/biz/file/view?fileId=1921761760910544898\"/></p><p><img style=\"max-width: 100%\" src=\"/main/biz/file/view?fileId=1921761788358070274\"/></p><p><img style=\"max-width: 100%\" src=\"/main/biz/file/view?fileId=1921761819572080641\"/></p><p><img style=\"max-width: 100%\" src=\"/main/biz/file/view?fileId=1921761842116464641\"/></p><p><br/></p>","noticeForm":"0","pageViews":0,"isRelease":true,"tenantId":"1866028748747345922","createBy":"刘黎亮","createTime":"2025-05-12 10:58:32","updateBy":"rcAdmin","updateTime":"2025-07-14 10:41:23","readNum":29,"likeNum":0,"sumReadNum":null,"noticeTypeName":"水质公告"}]
            // let params = {
            //     noticeType: this.noticeType,
            // }
            let params = {
              page: { current:1, size:9999},
              noticeType: this.noticeType
            }
            const { status, resultData } = await selectNoticeList(params);
            if (status === 'complete') {
                if (resultData.count === 0) {
                    this.isNoData = true;
                } else {
                    this.newsList = resultData.entities;
                }
            }
        },
        async toNewsDetail(newsItem) {
            let res = await calcReadNum(newsItem.noticeId)
            console.log(res, '阅读计数')
            const { resultData } = await selectNoticeDetail(newsItem.noticeId);
            if (resultData.noticeForm === '1') {
                window.open(resultData.noticeDescribe, '_blank')
            } else {
                this.$router.push({
                    path: '/NewsNotice/NewsDetail',
                    query: {
                        noticeId: newsItem.noticeId,
                        pageTitle: this.pageTitle + '详情'
                    }
                })
            }
        },
        /* onRefresh() {
          this.newsList = [];
          this.currentPage = 1;
          this.finished = false;
          this.loading = false;
          this.wxSelectNoticePage();
        },
        onLoad() {
          this.wxSelectNoticePage('downRefresh');
        },
        async wxSelectNoticePage(type) {
          console.log(type, 'loadData')
          this.loading = true;
          let params = {
            noticeType: this.noticeType,
            page: {
              current: this.currentPage,
              size: this.pageSize
            }
          }
          const { status, resultData } = await wxSelectNoticePage(params);
          if (status === 'complete') {
            if (resultData.records.length) {
              this.currentPage++;
              this.newsList = [...this.newsList, ...resultData.records];
            } else {
              this.newsList = this.newsList;
              this.finished = true;
            }
            this.refreshing = false; // 关闭顶部加载中···
            this.loading = false; // 关闭底部加载中...

            // 判断返回数据长度等于pageSize，底部显示数据加载完成
            if (this.newsList.length <= this.pageSize) {
              this.finishedText = '数据加载完成';
            }

            if (this.newsList.length === Number(resultData.total)) {
              this.finished = true;
              this.finishedText = '没有更多了';
            }
          } else {
            this.loading = false;
          }
        }, */
    }
}
</script>

<style lang="less" scoped>
#NewsPage {
    padding: 16px;
    box-sizing: border-box;
    width: 100vw;
    height: 100vh;
    overflow: auto;
    font-size: 14px;
    color: #333;
    background-color: #F7F7F7;

    .news-box {
        position: relative;
        margin-top: 12px;
        padding: 16px;
        box-sizing: border-box;
        display: flex;
        background: #fff;
        box-shadow: 0 -2px 12px -10px rgba(53, 59, 68, 0.30);
        border-radius: 4px;

        &:first-child {
            margin-top: 0px;
        }

        .bg-text {
            color: rgb(255, 255, 255);
            font-weight: bold;
            position: absolute;
            line-height: 47px;
            width: 76px;
            text-align: center;
            letter-spacing: 1px;
            font-family: 黑体;
        }

        .news-left {
            width: 76px;
            height: 47px;
            border-radius: 4px;
        }

        .news-right {
            padding-left: 20px;
            width: calc(100% - 110px);
            display: flex;
            flex: 1;
            flex-direction: column;

            li:first-child {
                font-size: 16px;
                font-weight: 500;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
            }

            li:last-child {
                padding-top: 8px;
                color: #666;
            }
        }
    }

    .no-data-box {
        // display: flex;
        // align-items: center;
        // justify-content: center;
        height: 100vh;
        padding: 15px;
        box-sizing: border-box;
        border-radius: 8px;
        box-shadow: 2px 2px 4px 0 rgba(213, 218, 225, 0.30);
        background-color: #fff;

        div:first-child {
            font-size: 16px;
            font-weight: 700;
            text-align: center;
        }

        /deep/ .noData {
            margin-top: 3% !important;
        }
    }
}
</style>
